<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import {WINDOW_APP_FUNC_DEFINE} from "@/windowAppFunc";
export default {
  name: "App",
  provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
    return {
      reload: this.reload                                              
    }
  },
  data() {
    return{
      isRouterAlive: true                    //控制视图是否显示的变量
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false;            //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true;         //再打开
      }) 
    }
  },
  mounted() {
    // // rem
    // (function (doc, win) {
    //   var docEl = doc.documentElement,
    //       resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    //       recalc = function () {
    //         var clientWidth = docEl.clientWidth;
    //         if (!clientWidth) return;
    //         docEl.style.fontSize = 100 * (clientWidth / 750) + 'px';
    //       };
    //   if (!doc.addEventListener) return;
    //   win.addEventListener(resizeEvt, recalc, false);
    //   doc.addEventListener('DOMContentLoaded', recalc, false);
    // })(document, window);
    // 缩放
    // this.$nextTick(() => {
    //   // const urlChannelCode = getQuery('channelCode')
    //   // const urlCode = getQuery('code')
    //   // if (urlChannelCode && !urlCode) {
    //   //   this.$router.push({
    //   //     query: merge({})
    //   //   })
    //   // }
    //   // 如果在红云 通知红云H5需要获取系统信息
    //   if(window.webkit && window.webkit.messageHandlers.getHYConfig) {
    //     window.webkit.messageHandlers.getHYConfig.postMessage(null)
    //   }
    //   // 定义所有在window对象上的方法
    //   WINDOW_APP_FUNC_DEFINE(this)
    // })
    try {
      // 禁用双击缩放
      var lastTouchEnd = 0;
      document.addEventListener("touchstart", function(event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener(
        "touchend",
        function(event) {
          var now = new Date().getTime();
          if (now - lastTouchEnd <= 500) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        {
          passive: false
        }
      );
      // 禁用双指手势操作
      document.addEventListener("gesturestart", function(event) {
        event.preventDefault();
      });
    } catch (error) {}
  }
};
</script>

<style>
@import "./assets/style/index";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/App.vue